import PropTypes from "prop-types"
import React from "react"
import { Modal, ModalBody } from "reactstrap"
import { useTranslation } from "react-i18next"

const ConfirmModal = ({
  show,
  onDeleteClick,
  onCloseClick,
  buttonText,
  bodyTitle,
  isLoading
}) => {
  const {
    t,
    i18n: { language },
  } = useTranslation()
  return (
    <Modal size="md" isOpen={show} toggle={onCloseClick} centered={true}>
      <div className="modal-content">
        <ModalBody className="px-4 py-5 text-center">
          <button
            type="button"
            onClick={onCloseClick}
            className="btn-close position-absolute end-0 top-0 m-3"
          ></button>
          <div className="avatar-sm mb-4 mx-auto">
            <div className="avatar-title bg-primary text-primary bg-opacity-10 font-size-20 rounded-3">
              <i className="bx bx bx-copy"></i>
            </div>
          </div>
          <p className="text-muted font-size-16 mb-4">{bodyTitle}</p>

          <div className="hstack gap-2 justify-content-center mb-0">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onCloseClick}
            >
              {t("Close")}
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={onDeleteClick}
              disabled={isLoading}
            >
              {buttonText}
            </button>
          </div>
        </ModalBody>
      </div>
    </Modal>
  )
}

ConfirmModal.propTypes = {
  onCloseClick: PropTypes.func.isRequired,
  onDeleteClick: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  buttonText: PropTypes.string.isRequired,
  bodyTitle: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
}

ConfirmModal.defaultProps = {
  isLoading: false,
}

export default ConfirmModal
